import EntitySync from "./EntitySync";
import StandCollectionsApi from "../../api/references/standcollections";
import StandKitsSync from "./standkits";

class StandCollectionsSync extends EntitySync {
    constructor(props) {
        super(props, 'stand_collections', ['id', 'stand_id', 'title', 'deleted'])
    }

    startSync() {
        // старая база называлась collections (store collections), поле brand_id
        this.migrateLegacyDb('collections', 'collections', (row) => {
            const {brand_id, ...rest} = row
            return {...rest, stand_id: rest.stand_id ?? brand_id ?? 0}
        }).then(() => super.startSync())
    }

    async fetchData(params) {
        const data_ = await StandCollectionsApi.getList({
            search: '',
            page: 1,
            epp: 4000,
            ...params
        })

        const data = data_.data

        if (data.results) {
            return data.results
        }
    }

    collectionIdsForStand = async (standId) => {
        if (!standId) {
            return []
        }
        const kits = await new StandKitsSync().getList({
            stand_id: standId,
            page: 1,
            epp: 500,
            search: '',
            show_deleted: false,
        })
        const ids = new Set()
        ;(kits.data.results || []).forEach(kit => {
            ;(kit.collection_ids || []).forEach(id => ids.add(String(id)))
        })
        return [...ids]
    }

    async getList(params) {
        try {
            const {search = '', epp, page} = params
            let ids = params.ids ? String(params.ids).split(',').filter(Boolean) : []
            if (params.stand_id) {
                const fromKits = await this.collectionIdsForStand(params.stand_id)
                ids = ids.length ? ids.filter(id => fromKits.indexOf(String(id)) !== -1) : fromKits
            }
            const show_deleted = params.show_deleted ?? true
            const limitByIds = !!(params.ids || params.stand_id)

            const checkSearch = el => {
                let check = true

                if (limitByIds && ids.indexOf(el.id.toString()) === -1) {
                    check = false
                }
                if (search.trim().length > 0 && check) {
                    if (!el.title.toLowerCase().includes(search.trim().toLowerCase())) check = false
                }
                if (!show_deleted && check) {
                    if (Number(el.deleted) === 1) check = false
                }
                return check
            }

            const total = await this.db[this.entityName]
                .filter(el => checkSearch(el))
                .count()

            const results = await this.db[this.entityName].orderBy('title')
                .filter(el => checkSearch(el))
                .offset((page - 1) * epp)
                .limit(epp)
                .toArray()

            const iTotalPages = Math.ceil(total / epp)

            return {
                data: {
                    results,
                    total,
                    iTotalPages,
                    iTotalRecords: total,
                    iTotalDisplayRecords: results.length
                }
            }
        } catch (error) {
            console.error('Ошибка при получении списка с поиском и пагинацией:', error)
            return {
                data: {
                    results: [],
                    total: 0,
                    iTotalPages: 0
                }
            }
        }
    }
}

export default StandCollectionsSync
